import { Component, Input, OnInit } from '@angular/core';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { google } from '@google/maps';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as QRCode from 'qrcode';

import { environment } from 'src/environments/environment';
import { CommunicationsService } from 'src/app/Shared/Commnunication/communications.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Shared/Common/common.service';

declare var $: any;
declare var google: any; // Declare 'google' as a global variable

@Component({
  selector: 'app-property-info-modal',
  templateUrl: './property-info-modal.component.html',
  styleUrls: ['./property-info-modal.component.css']
})
export class PropertyInfoModalComponent implements OnInit {
  closeImagePreview() {
    ($('#imagePreviewModal') as any).modal('hide');
    try { document.removeEventListener('keydown', this._keyDownHandler); } catch { }
  }

  previewImgSrc: string = '';
  openImagePreview(imgSrc: string, index: number = 0) {
    this.current = index || 0;
    this.previewImgSrc = imgSrc;
    setTimeout(() => {
      ($('#imagePreviewModal') as any).modal('show');
      // attach keyboard listener while modal is open
      document.addEventListener('keydown', this._keyDownHandler);
    }, 0);
  }

  private _keyDownHandler = (e: KeyboardEvent) => {
    if ((document.getElementById('imagePreviewModal') as any)?.classList?.contains('show')) {
      if (e.key === 'ArrowLeft') this.prevImage();
      if (e.key === 'ArrowRight') this.nextImage();
      if (e.key === 'Escape') this.closeImagePreview();
    }
  }

  prevImage() {
    if (!this.propertyImagesList || this.propertyImagesList.length === 0) return;
    this.current = (this.current - 1 + this.propertyImagesList.length) % this.propertyImagesList.length;
    this.previewImgSrc = this.propertyImagesList[this.current];
  }

  nextImage() {
    if (!this.propertyImagesList || this.propertyImagesList.length === 0) return;
    this.current = (this.current + 1) % this.propertyImagesList.length;
    this.previewImgSrc = this.propertyImagesList[this.current];
  }

  goToImage(index: number) {
    if (!this.propertyImagesList || !this.propertyImagesList[index]) return;
    this.current = index;
    this.previewImgSrc = this.propertyImagesList[this.current];
  }

  @Input() PropertyId: any = 0;
  isLoader: boolean = false;
  PropertyInfo: any = {
    Amenities: []
  };
  current: number = 0;
  propertyImagesList: any[] = [];
  isSale: boolean = false;
  viewBaseImg: string = "";

  // To track the map view
  mapViewLatitudes: string = '';
  mapViewLongitudes: string = '';
  selectedPlaceType: string = ''; // Default place type
  map: google.maps.Map; // Declare map variable
  placesService: google.maps.places.PlacesService; // Declare PlacesService variable
  markers: google.maps.Marker[] = []; // Define markers array
  authData: any;
  userProfileInfo: any;
  Performance: any;

  constructor(private homePropertysService: PropertyPostsService, private viewCommunicationsService: CommunicationsService
    , private viewCommonService: CommonService, private viewhRouter: Router
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any) {
    this.current = 0;
    if (changes.PropertyId != undefined && changes.PropertyId.currentValue != undefined) {
      this.PropertyId = changes.PropertyId.currentValue;
      if (this.PropertyId != null && this.PropertyId != 0) {
        this.LoadPropertyDetails();
      }
    }
  }

  LoadPropertyDetails() {
    try {
      this.isLoader = true;
      this.propertyImagesList = [];
      this.viewBaseImg = "";
      this.PropertyInfo = [];

      const modalEl = $('#PropertyDetailsModel');
      const modalIsVisible = modalEl.hasClass('show');

      const loadDataAndShowModal = () => {
        this.homePropertysService.GetPropertyInfoById(this.PropertyId).subscribe(res => {
          this.isLoader = false;

          if (res.status === 1) {
            const responseData = res.body;
            this.PropertyInfo = responseData?.Rent?.[0] || responseData?.Sale?.[0] || null;

            if (this.PropertyInfo) {
              this.Performance = JSON.parse(this.PropertyInfo.Performance || '{}');
              this.isSale = this.PropertyInfo?.Req_Type === 'S';
              const images = [
                this.PropertyInfo.Image1,
                this.PropertyInfo.Image2,
                this.PropertyInfo.Image3,
                this.PropertyInfo.Image4,
                this.PropertyInfo.Image5,
                this.PropertyInfo.Image6,
                this.PropertyInfo.Image7
              ].filter(img => img && img !== "");

              this.propertyImagesList = images;
              this.viewBaseImg = images[0] || "";

              // Show modal
              modalEl.modal('show');

              this.mapViewLatitudes = this.PropertyInfo.Latitude;
              this.mapViewLongitudes = this.PropertyInfo.Longitude;
              if (this.PropertyInfo?.Amenities) {
                try {
                  this.PropertyInfo.Amenities = JSON.parse(this.PropertyInfo.Amenities);
                } catch {
                  this.PropertyInfo.Amenities = [];
                }
              } else {
                this.PropertyInfo.Amenities = [];
              }

              setTimeout(() => {
                this.initMap();
                this.CallStreetView();
              }, 100);
            }
          }
        }, err => {
          console.error('API error:', err);
          this.isLoader = false;
        });
      };

      if (modalIsVisible) {
        // Modal is open â†’ hide it and wait
        modalEl.modal('hide');
        modalEl.one('hidden.bs.modal', loadDataAndShowModal);
      } else {
        // Modal already hidden â†’ load immediately
        loadDataAndShowModal();
      }

    } catch (error) {
      console.error('Unexpected error:', error);
      this.isLoader = false;
    }
  }




  CallStreetView() {
    try {
      setTimeout(() => {
        this.selectedPlaceType = 'streetView';
        this.initMapStreetView();
      }, 1000);
    } catch (error) {

    }
  }


  // Method to initialize map
  initMap(): void {
    if (!google || !google.maps) {
      console.error('Google Maps API is not loaded.');
      return;
    }
    const lat = this.mapViewLatitudes;
    const lng = this.mapViewLongitudes;
    const center = new google.maps.LatLng(lat, lng);

    // Check if map and street view divs exist
    const mapDiv = document.getElementById('map');
    mapDiv.style.display = 'block';

    // Wait until the elements are available in the DOM
    if (!mapDiv) {
      setTimeout(() => {
        this.initMap();
      }, 100);
      return;
    }
    // Create a new map instance and assign it to this.map
    this.map = new google.maps.Map(mapDiv, {
      center: center,
      zoom: 14
    });

    // Clear existing markers
    this.clearMarkers();

    // Create a marker for the property location
    const propertyMarker = new google.maps.Marker({
      position: center,
      map: this.map,
      title: 'Property Location',
      icon: {
        url: 'https://buyrentsale.com/assets/icons/location.png',
        scaledSize: new google.maps.Size(40, 40),
        zIndex: 1000
      }
    });

    // Add the property marker to the markers array
    this.markers.push(propertyMarker);

    // Perform nearby search only if a place type is selected
    if (this.selectedPlaceType && this.selectedPlaceType != '') {
      let requestType: string;
      requestType = this.selectedPlaceType;

      const request = {
        location: center,
        radius: 1000,
        type: requestType
      };

      this.placesService = new google.maps.places.PlacesService(this.map);

      this.placesService.nearbySearch(request, (results: google.maps.places.PlaceResult[], status: google.maps.places.PlacesServiceStatus) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (const result of results) {
            this.addMarker(result);
          }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        } else {
          console.error('Places API request failed:', status);
        }
      });
    }
  }

  initMapStreetView(): void {
    if (!google || !google.maps) {
      console.error('Google Maps API is not loaded.');
      return;
    }
    const lat = this.mapViewLatitudes;
    const lng = this.mapViewLongitudes;
    const center = new google.maps.LatLng(lat, lng);

    // Check if map and street view divs exist
    const streetViewDiv = document.getElementById('street-view');
    streetViewDiv.style.display = 'block';

    // Wait until the elements are available in the DOM
    if (!streetViewDiv) {
      setTimeout(() => {
        this.initMapStreetView();
      }, 100);
      return;
    }
    const streetViewPanorama = new google.maps.StreetViewPanorama(streetViewDiv, {
      position: center,
      pov: {
        heading: 34,
        pitch: 10
      },
      visible: true
    });

    this.map.setStreetView(streetViewPanorama);

  }

  addMarker(place: google.maps.places.PlaceResult): void {
    if (place.geometry && place.geometry.location) {
      let iconUrl = '';

      switch (this.selectedPlaceType) {
        case 'hospital':
          iconUrl = 'https://buyrentsale.com/assets/icons/hospital.png';
          break;
        case 'school':
          iconUrl = 'https://buyrentsale.com/assets/icons/school.png';
          break;
        case 'restaurants':
          iconUrl = 'https://maps.google.com/mapfiles/ms/icons/restaurants.png';
          break;
        case 'supermarket':
          iconUrl = 'https://buyrentsale.com/assets/icons/shop.png';
          break;
        case 'bank':
          iconUrl = 'https://buyrentsale.com/assets/icons/bank.png';
          break;
        default:
          iconUrl = 'https://buyrentsale.com/assets/icons/location.png'; // Default icon
          break;
      }

      // Create a marker for the place and add it to the map
      const marker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: place.name,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(24, 24) // Define custom size
        }
      });

      // Add the marker to the markers array
      this.markers.push(marker);
    }
  }

  clearMarkers(): void {
    // Iterate over the markers array and remove each marker from the map
    for (const marker of this.markers) {
      marker.setMap(null);
    }
    // Clear the markers array
    this.markers = [];
  }

  loadBaseImage(p: string) {
    this.viewBaseImg = p;
  }

  closeModel() {
    $('.modal').modal('hide');
    this.isLoader = false;
    try { document.removeEventListener('keydown', this._keyDownHandler); } catch { }
  }

  async doContactAgent(cType: string, rType: any) {
    // Wait for authentication check
    const isAuthenticated = await this.handleAuthenticationAndGuest(false);

    // If user is not authenticated or is a guest, return early
    if (!isAuthenticated) {
      this.isLoader = false; // Ensure loader is turned off when modal is shown
      return;
    }

    try {
      this.isLoader = true;  // Start loader
      if (this.authData.UserID) {
        let data = {
          CommunicationID: 0,
          RequestID: rType.RequestID,
          UserID: this.authData.UserID,
          Communication_Type: cType
        };

        this.viewCommunicationsService.AddUpdateMessageInfo(JSON.stringify(data)).subscribe(res => {
          this.isLoader = false; // Turn off loader
          if (res && res.status === 1) {
            if (res.body === 1) {
              if (cType === 'Call') {
                setTimeout(() => {
                  document.location.href = "tel:" + rType.MobileNo + "";
                }, 500);
              } else {
                this.SendContactSMS(rType);
                this.viewCommonService.CallToster('S', 'Your Request is Communicated successfully');
              }
            } else {
              this.viewCommonService.CallToster('E', 'Already contacted or something went wrong.');
            }
          } else {
            this.viewCommonService.CallToster('E', res.errorMessage || 'Already contacted or something went wrong.');
          }
        }, err => {
          this.isLoader = false; // Turn off loader on error
          this.viewCommonService.CallToster('E', 'Something went wrong, Please try again later.');
        });
      }
    } catch (error) {
      this.isLoader = false; // Turn off loader on exception
      this.viewCommonService.CallToster('E', 'Unable to submit your details, Please try again later.');
    }
  }

  SendContactSMS(code: any) {
    try {

      let Text = "Congratulations! Important update from Buyrentsale.com on your property " + code.Property_Code + ". Log in for more information. - AINEXT IT";
      this.viewCommonService.SendSMS(Text, code.MobileNo).subscribe(res => {
        //console.log(res);
      }, err => {
        //console.log(err);
      });
    } catch (error) {
      //console.log(error);
    }
  }

  private async handleAuthenticationAndGuest(isMyProfile: boolean): Promise<boolean> {
    // Check if the user is authenticated
    if (this.CheckAuthentication()) {
      const userName = this.authData.UserName;

      // Check if the authenticated user is a guest
      if ((typeof userName === 'string' && userName.toLowerCase() === 'guest') || isMyProfile == true) {
        this.isLoader = true;  // Start loader before navigation
        // Navigate to profile page for guest user
        try {
          this.closeModel(); // Close the modal if it's open
          setTimeout(() => {
            this.viewhRouter.navigate(['/myprofile']);
          }, 1000);
        } catch (error) {
        } finally {
          this.isLoader = false;  // Stop loader after navigation completes
        }
        return false; // Return false for guest users to stop further execution
      }
      return true; // Authenticated user, allow execution to proceed
    } else {
      this.viewCommonService.CallToster('E', 'Please login into to contact.');
      return false; // Return false to stop further execution
    }
  }

  private CheckAuthentication(): boolean {
    // Fetch the data from localStorage
    const authDataString = localStorage.getItem('authData');
    const authProfileString = localStorage.getItem('authProfileData');

    // Safely parse JSON only if the data exists and is valid
    try {
      // Check if authDataString is not null, undefined, or empty before parsing
      if (authDataString && authDataString !== 'undefined' && authDataString.trim() !== '') {
        this.authData = JSON.parse(authDataString);
      } else {
        this.authData = null; // Treat as unauthenticated
      }

      // If authProfileString is undefined, do not attempt to parse it
      if (authProfileString && authProfileString !== 'undefined' && authProfileString.trim() !== '') {
        this.userProfileInfo = JSON.parse(authProfileString);
      } else {
        this.userProfileInfo = null; // Clear user profile info since it's undefined
      }
    } catch (e) {
      console.error("Error parsing JSON from localStorage:", e);
      return false; // If there's a parsing error, treat as not authenticated
    }

    // Check if authData exists and is an object
    if (!this.authData || typeof this.authData !== 'object') {
      return false; // Return false if not authenticated
    }

    // Authentication succeeded
    return true;
  }


  captureAndDownload(sale: any) {
    try {
      this.isLoader = true;
      const element = document.getElementById(`property-info-${sale.RequestID}`) as HTMLElement | null;
      if (!element) {
        this.isLoader = false;
        return;
      }

      const divBlock = element.querySelector('.block') as HTMLElement | null;
      if (divBlock) divBlock.style.display = 'none';

      const images = element.getElementsByTagName('img');
      const totalImages = images.length;
      let loadedImages = 0;

      const checkImagesLoaded = (callback: Function) => {
        for (let i = 0; i < totalImages; i++) {
          if (images[i].complete) {
            loadedImages++;
          } else {
            images[i].onload = () => {
              loadedImages++;
              if (loadedImages === totalImages) callback();
            };
          }
        }
        if (loadedImages === totalImages) callback();
      };

      checkImagesLoaded(() => {
        setTimeout(() => {
          html2canvas(element, {
            useCORS: true,
            allowTaint: false,
            scale: 1,
            ignoreElements: el => el.tagName === 'VIDEO'
          }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.5);
            const totalContentHeight = canvas.height + 200;
            const pdf = new jsPDF('p', 'pt', [canvas.width, totalContentHeight]);
            const pdfWidth = pdf.internal.pageSize.getWidth();

            const margin = 20;
            const logoWidth = 100;
            const logoHeight = 50;
            const qrCodeX = pdfWidth - margin - 100;
            const qrCodeUrl = `${environment.apiUrl}/m/searchproperty?propertycode=${sale.Property_Code}`;

            const drawImages = (logoImage: HTMLImageElement | null) => {
              if (logoImage) {
                pdf.addImage(logoImage, 'PNG', margin, margin, logoWidth, logoHeight);
              }

              QRCode.toDataURL(qrCodeUrl, { width: 100 }, (err, qrCodeData) => {
                if (err) {
                  console.error('Error generating QR code:', err);
                } else {
                  pdf.addImage(qrCodeData, 'PNG', qrCodeX, margin, 100, 100);
                  pdf.setFontSize(12);
                  pdf.text('Scan QR code', qrCodeX, margin + 115);
                }

                // Add the captured content (DOM with property image) below the QR code
                const contentY = margin + 140;
                pdf.addImage(imgData, 'JPEG', margin, contentY, pdfWidth - 2 * margin, canvas.height * (pdfWidth - 2 * margin) / canvas.width);

                // Save PDF
                pdf.save(`${sale.Property_Title}.pdf`);

                this.isLoader = false;
                if (divBlock) divBlock.style.display = 'block';
              });
            };

            // Load logo image
            const logoImage = new Image();
            logoImage.crossOrigin = 'anonymous';
            logoImage.src = environment.appLogoURL;
            logoImage.onload = () => drawImages(logoImage);
            logoImage.onerror = () => {
              drawImages(null); // Continue without logo
            };
          }).catch(err => {
            console.error('Capture error:', err);
            this.isLoader = false;
            if (divBlock) divBlock.style.display = 'block';
          });
        }, 1000);
      });
    } catch (error) {
      this.isLoader = false;
      console.error('Error in captureAndDownload:', error);
    }
  }


  share(property: any): void {
    const url = `${environment.apiUrl}/m/searchproperty?propertycode=${property.Property_Code}`;
    const shareData = {
      title: `Buy Rent Sale - ${property.Property_Title}`,
      text: `Hi, I recommend this great Property found on BuyRentSale.com: ${property.Property_Title} in ${property.Address}  Note : Login before to View Property details `,
      url: url,
    };

    if ((navigator as any).share) {
      // Share the data using Web Share API
      (navigator as any).share(shareData)
        .then(() => console.log('Successfully shared'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      console.log('Web Share API is not supported in this browser.');
    }
  }

}
